import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import UserHeaderButtons from "@/components/Header/User";
import { TAB_KEYS } from "@/constants/TabKeys";
import { useGetUser, USER_INCLUDES } from "@/entities/user";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";
import { TabView } from "@/ui/tab-view";

import TabInterventions from "./TabInterventions";
import { TabRolesAndPermissions } from "./TabRolesAndPermissions";

const UserDetails = () => {
  const id = useIdParam();
  const { t } = useTranslation();

  const include = [USER_INCLUDES.ORGANIZATION, USER_INCLUDES.ROLES];

  const { isLoading, user, error } = useGetUser(id, {
    params: { include: include.join(",") },
  });

  const tabs = [
    {
      key: TAB_KEYS.USERS_INTERVENTIONS,
      label: t("global:interventionPlural"),
      children: <TabInterventions userId={id} />,
    },
    {
      key: TAB_KEYS.USERS_ROLES,
      label: `${t("user:rolePlural")} ${t("global:and")} ${t(
        "user:permissionPlural"
      )}`,
      children: <TabRolesAndPermissions user={user} loading={isLoading} />,
    },
  ];

  return (
    <PageItemGate model="user" queryError={error}>
      <BaseHeader
        title={user?.name}
        loading={isLoading}
        extra={
          !isLoading && [
            <UserHeaderButtons key="UserHeaderButtons" user={user} />,
          ]
        }
      />
      <AppLayoutPage>
        <TabView isNav tabs={tabs} defaultActiveKey="interventions" />
      </AppLayoutPage>
    </PageItemGate>
  );
};

export default UserDetails;
